import { useEffect, useState } from 'react';

/**
 * Returns true while the browser tab is foreground-visible. Used to gate
 * polling RTK Query subscriptions so we don't burn upstream quota for data
 * nobody is watching.
 *
 * Telegram-specific viewport collapse (viewport.isCollapsed) is NOT gated
 * here in v1 — matches the precedent in src/hooks/useChat.ts. Add a
 * useSignal(viewport.isCollapsed) check if real usage warrants it.
 */
export function useIsVisible(): boolean {
  const [visible, setVisible] = useState(() =>
    typeof document === 'undefined' ? true : document.visibilityState === 'visible',
  );
  useEffect(() => {
    const onChange = () => setVisible(document.visibilityState === 'visible');
    document.addEventListener('visibilitychange', onChange);
    return () => document.removeEventListener('visibilitychange', onChange);
  }, []);
  return visible;
}
